import React from 'react';
import { useStaticQuery, graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const BblTextIntroBlock = (props) => {

    const data = useStaticQuery(graphql`
        query textIntroOverrides {
            wp {
                themeOptions {
                    ThemeOptions {
                        textIntro {
                            backgroundColour
                            headerColour
                            paragraphColour
                        }
                    }
                }
            }
        }`);

    let overrides = data.wp.themeOptions.ThemeOptions.textIntro;

    if(props.innerBlocks[0].attributes.textColor === "" && overrides.headerColour !== 'black') {
        props.innerBlocks[0].attributes.textColor = overrides.headerColour;
    }

    if(props.innerBlocks[1].attributes.textColor === "" && overrides.paragraphColour !== 'black') {
        props.innerBlocks[1].attributes.textColor = overrides.paragraphColour;
    }

    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={` ${props.attributes.className ? props.attributes.className : ''} ${classes.textIntro} `}
                data-thin={ props.attributes.isThin }
                data-override-background={overrides.backgroundColour !== 'background' ? overrides.backgroundColour : null}
    >
        <div className="wrapper">
            {blocks[0]}
            {blocks[1]}
            { props.attributes.hasButton &&
                blocks[2]
            }
        </div>
    </div>
};

export const BblTextIntroBlockFragment = graphql`
  fragment BblTextIntroBlock on WpBlock {
    ... on WpBblTextIntroBlock {
        name
        attributes {
            className
            hasButton
            isThin
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const BblTextIntroBlockPreview = `
    ... on BblTextIntroBlock {
        name
        attributes {
            className
            hasButton
            isThin
        }
    }
`;